import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, formatApiErrorDetail } from "../api";
import Logo from "../components/Logo";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#16181D] px-4">
      <div className="w-full max-w-sm rounded-2xl border border-[#2D323E] bg-[#1E2128] p-8">
        <div className="mb-8 flex justify-center">
          <Logo />
        </div>
        {sent ? (
          <div data-testid="forgot-password-confirmation" className="text-center">
            <h1 className="mb-2 font-heading text-xl font-bold">Revisa tu correo</h1>
            <p className="text-sm leading-relaxed text-[#8A8F98]">
              Si ese correo está registrado, recibirás un enlace para restablecer tu contraseña.
              El enlace caduca en 1 hora.
            </p>
          </div>
        ) : (
          <>
            <h1 className="mb-1 text-center font-heading text-xl font-bold">Recuperar contraseña</h1>
            <p className="mb-7 text-center text-sm text-[#8A8F98]">
              Te enviaremos un enlace de restablecimiento
            </p>
            <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-password-form">
              <div>
                <Label htmlFor="fp-email" className="text-[#8A8F98]">Email</Label>
                <Input
                  id="fp-email"
                  data-testid="forgot-password-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1.5 border-[#2D323E] bg-[#16181D] text-[#F2F4F6]"
                  placeholder="tu@email.com"
                />
              </div>
              {error && (
                <p data-testid="forgot-password-error" className="rounded-lg border border-[#EF4444]/40 bg-[#EF4444]/10 px-3 py-2 text-sm text-[#EF4444]">
                  {error}
                </p>
              )}
              <button
                type="submit"
                data-testid="forgot-password-submit-btn"
                disabled={loading}
                className="w-full rounded-xl bg-gradient-to-r from-[#2EE6D6] to-[#7C5CFF] py-3 font-bold text-black transition-opacity hover:opacity-90 disabled:opacity-50"
              >
                {loading ? "Enviando…" : "Enviar enlace"}
              </button>
            </form>
          </>
        )}
        <div className="mt-6 text-center">
          <Link to="/admin/login" data-testid="back-to-login-link" className="inline-flex items-center gap-1.5 text-sm text-[#8A8F98] transition-colors hover:text-[#F2F4F6]">
            <ArrowLeft className="h-4 w-4" /> Volver a iniciar sesión
          </Link>
        </div>
      </div>
    </div>
  );
}
